.infoText {
  color: var(--body-text-arrows-400);
}

.form-field-info-text {
  padding-top: calc(var(--spacer) * 2);
}

#proxy-configuration-form-fields {
  margin-left: calc(var(--spacer) * 5.3);
}

.disabled {
  opacity: 0.5;
  pointer-events: none;
}

gz-checkbox {
  width: auto;
}
